import { DeviceDetectorService } from 'ngx-device-detector';
import { CanActivate, Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable()
export class DeviceGuard implements CanActivate {
    deviceInfo = null;
    constructor(public router: Router, private deviceService: DeviceDetectorService) { }

    canActivate(): boolean {
        // this.deviceInfo = this.deviceService.getDeviceInfo();
        // const isMobile = this.deviceService.isMobile();
        // if (isMobile) {
        //     window.location.href = environment.mobileUrl;
        // }
        return true;
    }
}
